'use client'

import { ComponentProps } from 'react'
import { IMAGE_PATH } from '../../config/constants'
import SectionTitle from '@/app/(site)/(static)/about/components/section-title'
import { cn } from '@/util/cn'
import VALUES from './values'
import Typography from '@/app/components/typography'

const GRADIENTS = [
    'bg-[linear-gradient(-135deg,_rgb(255,_102,_102)_0%,_rgb(230,_70,_182)_100%)]',
    'bg-[linear-gradient(-135deg,_rgb(153,_51,_255)_0%,_rgb(97,_87,_255)_100%)]',
    'bg-[linear-gradient(45deg,_rgb(255,_102,_102)_0%,_rgb(255,_243,_92)_100%)]',
    'bg-[linear-gradient(-135deg,_rgb(0,_255,_153)_0%,_rgb(0,_204,_255)_100%)]',
] as const

type Props = {
    sectionTitleProps?: Partial<ComponentProps<typeof SectionTitle>>
    className?: string
}

const PhilosophiesAndValuesSection = ({ sectionTitleProps, className }: Props) => (
    <section id="philosophies-and-values" className={className}>
        <div className="relative">
            <SectionTitle
                title="Our Philosophies"
                description="This is what we believe. These philosophies guide our approach to GIPHY's community, culture, and products."
                src={`${IMAGE_PATH}/stickers/third-eye.gif`}
                {...sectionTitleProps}
                classNames={{
                    ...sectionTitleProps?.classNames,
                    base: cn('mb-[1.125rem] [--img-dimension:7.8rem]', sectionTitleProps?.classNames?.base),
                }}
            />

            <div className="w-full max-w-[1224px] flex flex-col mt-12 md:mt-[92px] mx-auto">
                {VALUES.map(({ title, description, src }, index) => {
                    const reverseOnDesktop = index % 2 !== 0
                    const gradientClass = GRADIENTS[index % GRADIENTS.length]

                    return (
                        <div
                            key={index}
                            className="grid gap-4 my-2.5 md:my-5 place-items-center md:grid-cols-2 md:min-h-[19.5rem]"
                        >
                            <img
                                src={src}
                                alt=""
                                className={cn(
                                    'w-full h-40 md:h-[312px] object-cover rounded-lg md:order-1',
                                    reverseOnDesktop && 'md:order-2'
                                )}
                            />

                            <div
                                className={cn(
                                    'w-full flex flex-col justify-center md:px-8 lg:px-0 py-4 md:order-2',
                                    reverseOnDesktop && 'md:order-1'
                                )}
                            >
                                <div className="w-full md:max-w-[28.125rem] text-left mx-auto">
                                    <Typography
                                        variant="h2"
                                        fontFamily="nexaBlack"
                                        className={cn(
                                            `bg-clip-text text-transparent font-black mb-5`, gradientClass,
                                        )}
                                    >
                                        {title}
                                    </Typography>

                                    <Typography variant="text-lg">{description}</Typography>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    </section>
)

export default PhilosophiesAndValuesSection
